
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/410",
      function () {
        return require("private-next-pages/410.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/410"])
      });
    }
  